<template>
    <ul class="tab_st03 mb-20">
        <li v-for="tab in tabList" :key="tab.code" style="cursor:pointer;">
            <a style="font-weight: bold;" :class="[selectedLfcnvncTab == tab.code? 'on' : '']" v-html="tab.title" @click.prevent="selectTab(tab.code)"></a>
        </li>
    </ul>
</template>

<script>

import { mapGetters } from 'vuex';
import { $_WC } from '@/confs/common.const.js';

export default {
    data() {
        return {
        }
    },
    watch: {
        
    },
    components: {
    },
    computed: {
        ...mapGetters({
            tabList: 'getTablist',
            selectedLfcnvncTab: 'getSelectedLfcnvncTab',
        }),
    },
    created() {
    },
    methods: {
        selectTab(code) {
            this.$store.dispatch("SET_SELECTED_LFCNVNC_TAB", code);
        },
    },
};
</script>
